import { StageDefinition } from './StageDefinition';

export const stage13: StageDefinition = {
    platforms: [
        [58.064516129032256, 0],
        [139.3548387096774, 0],
        [313.5483870967743, 0],
        [56.84210526315789, 1],
        [151.57894736842104, 1],
        [179.99999999999994, 1],
        [322.10526315789446, 1],
        [57.272727272727266, 2],
        [163.63636363636368, 2],
        [327.2727272727274, 2],
        [172.79999999999995, 3],
        [183.15789473684214, 4],
        [195.78947368421058, 4],
        [214.73684210526324, 4],
        [221.05263157894746, 4],
        [334.7368421052634, 4],
        [234.28571428571436, 5],
        [240.00000000000009, 5],
        [245.7142857142858, 5],
        [251.42857142857153, 5],
        [274.2857142857144, 5],
        [280.0000000000001, 5],
        [285.71428571428584, 5],
        [291.42857142857156, 5],
        [337.14285714285734, 5],
        [292.1739130434779, 6],
        [339.13043478260823, 6],
        [57.59999999999999, 7],
        [292.80000000000035, 7],
        [340.80000000000047, 7],
        [57.07317073170732, 8],
        [114.14634146341464, 8],
        [294.14634146341416, 8],
        [342.4390243902433, 8],
        [4.090909090909091, 9],
        [8.181818181818182, 9],
        [12.272727272727273, 9],
        [16.363636363636363, 9],
        [20.454545454545453, 9],
        [24.545454545454543, 9],
        [28.636363636363633, 9],
        [32.72727272727273, 9],
        [36.81818181818182, 9],
        [40.909090909090914, 9],
        [45.00000000000001, 9],
        [49.0909090909091, 9],
        [53.181818181818194, 9],
        [57.27272727272729, 9],
        [61.36363636363638, 9],
        [65.45454545454547, 9],
        [69.54545454545456, 9],
        [73.63636363636365, 9],
        [77.72727272727275, 9],
        [81.81818181818184, 9],
        [85.90909090909093, 9],
        [90.00000000000003, 9],
        [94.09090909090912, 9],
        [98.18181818181822, 9],
        [102.27272727272731, 9],
        [106.3636363636364, 9],
        [110.4545454545455, 9],
        [114.54545454545459, 9],
        [118.63636363636368, 9],
        [122.72727272727278, 9],
        [126.81818181818187, 9],
        [130.90909090909096, 9],
        [135.00000000000006, 9],
        [139.09090909090915, 9],
        [143.18181818181824, 9],
        [147.27272727272734, 9],
        [151.36363636363643, 9],
        [155.45454545454552, 9],
        [159.54545454545462, 9],
        [163.6363636363637, 9],
        [167.7272727272728, 9],
        [171.8181818181819, 9],
        [175.909090909091, 9],
        [180.00000000000009, 9],
        [184.09090909090918, 9],
        [188.18181818181827, 9],
        [192.27272727272737, 9],
        [196.36363636363646, 9],
        [200.45454545454555, 9],
        [204.54545454545465, 9],
        [208.63636363636374, 9],
        [212.72727272727283, 9],
        [216.81818181818193, 9],
        [220.90909090909102, 9],
        [225.0000000000001, 9],
        [229.0909090909092, 9],
        [233.1818181818183, 9],
        [237.2727272727274, 9],
        [241.3636363636365, 9],
        [290.4545454545454, 9],
        [294.54545454545445, 9],
        [298.6363636363635, 9],
        [302.7272727272726, 9],
        [306.81818181818164, 9],
        [310.9090909090907, 9],
        [314.9999999999998, 9],
        [319.09090909090884, 9],
        [323.1818181818179, 9],
        [327.27272727272697, 9],
        [331.36363636363603, 9],
        [335.4545454545451, 9],
        [339.54545454545416, 9],
        [351.81818181818136, 9],
        [355.9090909090904, 9],
        [359.9999999999995, 9],
    ],
    traps: [
        [104.51612903225805, 0],
        [243.87096774193557, 0],
        [165.59999999999997, 3],
        [331.1999999999997, 3],
        [286.9565217391301, 6],
        [288.00000000000034, 7],
        [289.75609756097515, 8],
    ],
    stars: [
        [195, 6],
        [337, 8],
        [274, 8],
        [347, 8],
    ],
};
